export const FETCH_PAGE_PENDING = 'FETCH_PAGE_PENDING';
export const FETCH_PAGE_FULFILLED = 'FETCH_PAGE_FULFILLED';
export const FETCH_PAGE_FAILED = 'FETCH_PAGE_FAILED';
export const FETCH_INITIAL_PAGE_FULFILLED = 'FETCH_INITIAL_PAGE_FULFILLED';
export const FETCH_PAGE_SETTINGS_PENDING = 'FETCH_PAGE_SETTINGS_PENDING';
export const FETCH_PAGE_SETTINGS_FULFILLED = 'FETCH_PAGE_SETTINGS_FULFILLED';
export const FETCH_PAGE_SETTINGS_FAILED = 'FETCH_PAGE_SETTINGS_FAILED';
